import { SharedDocumalisModule } from '@documalis/shared-documalis.module';
import { NgModule } from '@angular/core';
import { BasketRoutes } from './basket.routes';
import { ListBasketsComponent } from './list-baskets/list-baskets.component';
import { FormBasketComponent } from './_components/form-basket/form-basket.component';
import { AddBasketComponent } from './add-basket/add-basket.component';
import { EditBasketComponent } from './edit-basket/edit-basket.component';
import { TranslateModule } from '@ngx-translate/core';
import { InputSwitchModule } from 'primeng/inputswitch';
import { FieldsetModule } from 'primeng/fieldset';
import { RadioButtonModule } from 'primeng/radiobutton';

@NgModule({
    imports: [BasketRoutes, SharedDocumalisModule, TranslateModule, InputSwitchModule, FieldsetModule, RadioButtonModule],
    declarations: [ListBasketsComponent, AddBasketComponent, EditBasketComponent, FormBasketComponent],
})
export class BasketModule {}
